// Configuration
export { setWorldApiConfig, getWorldApiConfig, type WorldApiConfig } from './axios-instance';

// Generated API exports will be added here after running Orval
export * from './generated/api';
export * from './generated/schemas';

// Version
export const SDK_VERSION = '0.1.0';